import React from 'react';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Pagination from "react-js-pagination";
// import { Checkbox, CheckboxGroup } from 'react-checkbox-group';
import * as specialistActions from '../../actions/specialistActions';
import * as constant from '../../constants/constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConsultationAddress from './consultationAddress';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import $ from 'jquery';
import axios from "axios";
import {
	confirmAlert
} from 'react-confirm-alert';
import getSymbolFromCurrency from 'currency-symbol-map'
import Autocomplete from 'react-google-autocomplete';
import moment from 'moment-timezone';

var radioStyle = {
	height: 16,
	width: 18
}
let fee1Status, fee2Status, fee3Status;
let day1Status, day2Status, day3Status, day4Status;
class BookAppointment extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isReady: false,
			narrowFilterZipCode: false,
			narrowFilter: false,
			isSearch: false,
			isSearchHeader: false,
			specialistList: [],
			specializationList: [],
			currencyConversion: false,
			token: '',
			patientId: '',
			flag: '',
			page: '',
			// count: '',
			isLoader: true,
			specializationName: '',
			specialization: '',
			searchSpecialization: '',
			searchZipcode: localStorage.getItem('zipCode') ? localStorage.getItem('zipCode') : '',
			searchGender: '',
			feeRange: [],
			searchRateValue: [],
			searchDay: [],
			searchMileDistance: 0,
			activePage: 1,
			count: 15,
			spinner: false,
			//other consultation
			openModal: false,
			otherConsultationAddress: [],
			presentConsultationId: '',

			rate1Status: '',
			rate2Status: '',
			rate3Status: '',
			rate4Status: '',
			rate5Status: '',
			filterColapsableDistance: true,
			filterColapsablePatientReviews: true,
			filterColapsableAvailability: true,
			filterColapsableConsultationfees: true,
			filterColapsableGender: true,
			filterColapsableLanguage: true,
			logoutButton: false,
			localCurrency: null,
			searchCountryName: null,
			day1Status: false,
			day2Status: false,
			day3Status: false,
			day4Status: false,
			fee1Status: false, fee2Status: false, fee3Status: false,
			reviewCountClicked: false,
			otherMilesDistance: [],
			questionRatings: [],
			countryName: '',
			// questionRatings: [],
			toRange1: { value: '', IsValied: true, message: '' },
			toRange2: { value: '', IsValied: true, message: '' },
			toRange3: { value: '', IsValied: true, message: '' },
			fromRange1: { value: '', IsValied: true, message: '' },
			fromRange2: { value: '', IsValied: true, message: '' },
			fromRange3: { value: '', IsValied: true, message: '' },

		};
		this.goToCalendarPage = this.goToCalendarPage.bind(this);
		this.goToDetailsPage = this.goToDetailsPage.bind(this);
		this.onChange = this.onChange.bind(this);
		this.search = this.search.bind(this);
		this.onNarrowChange = this.onNarrowChange.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onChangeSelect = this.onChangeSelect.bind(this);
		this.openConsultationModal = this.openConsultationModal.bind(this);
		this.hideConsultationModal = this.hideConsultationModal.bind(this);
		this.getOtherConsultationAddress = this.getOtherConsultationAddress.bind(this);
		this.goToCalendarPageFromOtherConsulatation = this.goToCalendarPageFromOtherConsulatation.bind(this);
		this.filterColapsableClickedDistance = this.filterColapsableClickedDistance.bind(this)
		this.filterColapsableClickedPatientReviews = this.filterColapsableClickedPatientReviews.bind(this)
		this.filterColapsableClickedAvailability = this.filterColapsableClickedAvailability.bind(this)
		this.filterColapsableClickedConsultationfees = this.filterColapsableClickedConsultationfees.bind(this)
		this.filterColapsableClickedGender = this.filterColapsableClickedGender.bind(this)
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.currencyApi = this.currencyApi.bind(this);
		this.rebbonClick = this.rebbonClick.bind(this);
		this.reviewCount = this.reviewCount.bind(this)
		this.updateAddress = this.updateAddress.bind(this);

	}
	updateAddress(address) {
		let self = this;
		var placeSearch, autocomplete;
		var componentForm = {
			street_number: 'Street Number',
			route: 'Route',
			postal_town: 'Town',
			locality: 'locality',
			administrative_area_level_1: 'State ',
			country: 'country',
			postal_code: 'Zip Code'
		};

		for (var i = 0; i < address.address_components.length; i++) {
			var addressType = address.address_components[i].types[0];
			if (componentForm[addressType]) {
				let val = address.address_components[i][componentForm[addressType]];
				componentForm[addressType] = address.address_components[i].long_name;
			}

		}
		var zip = componentForm.postal_code != 'Zip Code' ? componentForm.postal_code + ', ' : ''
		var town = componentForm.postal_town != 'Town' ? componentForm.postal_town + ', ' : componentForm.locality != 'locality' ? componentForm.locality + ', ' : ''
		var country = componentForm.country != 'country' ? componentForm.country : ''
		country = country.toLowerCase()
			.split(' ')
			.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
			.join(' ');
		localStorage.setItem('country_long', country);

		self.setState({
			searchZipcode: zip + town + country,
			countryName: country
		})
	}
	reviewCount(index, id, e) {
		if (index == 'close') {
			this.setState({ reviewCountClicked: false })

		} else {
			let data = {
				doctorId: id
			}
			this.props.actions.getAvgRatingByQuestions(data);
			this.setState({ reviewCountClicked: 'feedbackPopup' + index })
		}
	}
	currencyApi(from, amt) {
		let data = {
			base: from,
			amount: amt
		}
		if (from != localStorage.getItem('currency') && localStorage.getItem('currency')) {
			console.log('yea:', data)
			this.setState({ currencyConversion: true })
			this.props.actions.currencychange(data);
		}
		else if (from == localStorage.getItem('currency')) {
			console.log('yea:', data)

		}
		else {
			toast.info('Plese turn on the Location');
		}
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	filterColapsableClickedDistance() {
		this.setState({ filterColapsableDistance: !this.state.filterColapsableDistance })
	}

	filterColapsableClickedPatientReviews() {
		this.setState({ filterColapsablePatientReviews: !this.state.filterColapsablePatientReviews })

	}

	filterColapsableClickedAvailability() {
		this.setState({ filterColapsableAvailability: !this.state.filterColapsableAvailability })

	}

	filterColapsableClickedConsultationfees() {
		this.setState({ filterColapsableConsultationfees: !this.state.filterColapsableConsultationfees })

	}

	filterColapsableClickedGender() {
		this.setState({ filterColapsableGender: !this.state.filterColapsableGender })

	}
	filterColapsableClickedLanguage = () => {
		this.setState({ filterColapsableLanguage: !this.state.filterColapsableLanguage })

	}
	getOtherConsultationAddress(doctorId, availId, index) {
		let obj = {
			doctorId: doctorId,
			isPrimaryAddress: false,
			latitude: parseFloat(localStorage.getItem('lat')),
			longitude: parseFloat(localStorage.getItem('lng')),
			searchZipcode: this.state.searchZipcode,
		}
		this.props.actions.getOtherConsultationAddress(obj);
		// this.openConsultationModal(availId);
		document.getElementById('addressPopUp' + index).style.display = 'block';

	}

	hideAddressPopUp(index) {
		document.getElementById('addressPopUp' + index).style.display = 'none';
	}

	openConsultationModal(availId) {
		var state = this.state;
		state.openModal = true;
		state.presentConsultationId = availId;
		this.setState(state);
	}
	hideConsultationModal() {
		var state = this.state;
		state.openModal = false;
		this.setState(state);
	}
	onChange(event) {
		this.setState({
			isReady: true,
			[event.target.name]: event.target.value
		});

	}

	onChangeSelect(event) {
		var selectedValue = this.state.specializationList[event.target.value]
		this.setState({
			isReady: true,
			specializationName: selectedValue.specialization,
			specialization: selectedValue._id
		});

	}

	// Capitalize(str) {
	// 	if (str != '' && str != undefined)
	// 		return str.charAt(0).toUpperCase() + str.slice(1);
	// 	else
	// 		return '';
	// }

	onNarrowChange(event) {
		// debugger
		this.setState({
			activePage: 1
		});
		let tableObj = {
			page: 1,
			count: 15,
			searchSpecialization: this.state.specialization,
			searchZipcode: this.state.searchZipcode,
			searchMileDistance: this.state.searchMileDistance,
			searchGender: this.state.searchGender,
			searchDay: this.state.searchDay,
			// countryName: this.state.countryName,
			searchRateValue: this.state.searchRateValue,
			feeRange: this.state.feeRange,
			latitude: parseFloat(localStorage.getItem('lat')),
			longitude: parseFloat(localStorage.getItem('lng')),
			date: new Date(),
			userLocation: moment.tz.guess()
		}
		let eventName = event.target.name;
		if (event.target.name === 'searchMileDistance') {
			if (event.target.value === '101') {
				tableObj['countryName'] = this.state.searchZipcode != '' ? this.state.countryName : localStorage.getItem('Currentcountry');
			} else {

				tableObj[eventName] = parseFloat(event.target.value)
			}
			this.setState({
				[event.target.name]: parseFloat(event.target.value)
			});
			localStorage.setItem('mileDistance', event.target.value);
		} else if (event.target.name === 'searchRateValue') {
			if (this.state.searchRateValue.indexOf(parseInt(event.target.value)) == -1) {
				this.state.searchRateValue.push(parseInt(event.target.value));
			} else {
				let index = this.state.searchRateValue.indexOf(parseInt(event.target.value));
				this.state.searchRateValue.splice(index, 1)
			}
			this.state["rate" + event.target.value + "Status"] = '';
			localStorage.setItem('rateValue', this.state.searchRateValue);
		}

		else if (event.target.name === 'searchDay') {
			if (this.state.searchDay.indexOf(event.target.value) == -1) {
				if (event.target.value == "Today") {
					this.state.searchDay.push(event.target.value);
					tableObj['count'] = 50

					localStorage.setItem('day1', "true");
				} else if (event.target.value == "Tomorrow") {
					this.state.searchDay.push(event.target.value);
					tableObj['count'] = 50

					localStorage.setItem('day2', "true");
				} else if (event.target.value == "All") {
					this.state.searchDay.push(event.target.value);

					localStorage.setItem('day3', "true");
				}
				else if (event.target.value == "All30") {
					this.state.searchDay.push(event.target.value);

					localStorage.setItem('day4', "true");
				}
			} else {
				let index = this.state.searchDay.indexOf(event.target.value);
				this.state.searchDay.splice(index, 1);
				if (event.target.value == "Today") {
					localStorage.setItem('day1', "");
					this.state.day1Status = "";

				} else if (event.target.value == "Tomorrow") {
					localStorage.setItem('day2', "");
					this.state.day2Status = "";
				} else if (event.target.value == "All") {
					localStorage.setItem('day3', "");
					day3Status = "";
				}
				else {
					localStorage.setItem('day4', "All30");
					this.state.day4Status = "";
				}


			}

		}

		else if (event.target.name === 'fee') {
			if (this.state.feeRange.indexOf(event.target.value) == -1) {
				if (event.target.value == this.state.toRange1.value) {
					this.state.feeRange.push(event.target.value);
					this.state.feeRange.push(this.state.fromRange1.value);
					localStorage.setItem('fee1', "true");
				} else if (event.target.value == this.state.toRange2.value) {
					this.state.feeRange.push(event.target.value);
					this.state.feeRange.push(this.state.fromRange2.value);
					localStorage.setItem('fee2', "true");
				} else if (event.target.value == this.state.toRange3.value) {
					this.state.feeRange.push(event.target.value);
					this.state.feeRange.push("gt");
					localStorage.setItem('fee3', "true");
				}
			} else {
				let index = this.state.feeRange.indexOf(event.target.value);
				this.state.feeRange.splice(index, 2);
				if (event.target.value == this.state.toRange1.value) {
					localStorage.setItem('fee1', "");
					this.state.fee1Status = "";

				} else if (event.target.value == this.state.toRange2.value) {
					localStorage.setItem('fee2', "");
					this.state.fee2Status = "";
				} else {
					localStorage.setItem('fee3', "");
					this.state.fee3Status = "";
				}
			}

		} else {
			this.setState({
				[event.target.name]: event.target.value
			}, () => {
				console.log("setting in the searchlenag0", this.state.searchLanguage)
			});
			tableObj[eventName] = event.target.value
		}
		if (event.target.name == "searchGender") {
			localStorage.setItem('gender', event.target.value);
		}
		// if (event.target.name == "searchLanguage") {
		// 	this.setState({
		// 		searchLanguage: event.target.value
		// 	}, () => {
		// 		console.log("this.state", this.state)
		// 	})
		// 	localStorage.setItem('language', event.target.value);
		// }
		this.props.actions.getSpecialistList(tableObj);
	}
	search() {

		console.log("this.state", this.state);


		if (this.state.specialization != undefined || this.state.searchZipcode != undefined) {
			this.setState({
				isSearch: true,
				narrowFilter: true,
				spinner: true
			});
			if (this.state.searchZipcode != '') {
				this.setState({
					narrowFilterZipCode: true,
					searchMileDistance: 100
				});
			}
			let tableObj = {
				page: 1,
				count: 15,
				searchSpecialization: this.state.specialization,
				searchZipcode: this.state.searchZipcode,
				searchMileDistance: this.state.searchMileDistance,
				searchGender: this.state.searchGender,
				searchDay: this.state.searchDay,
				searchRateValue: this.state.searchRateValue,
				feeRange: this.state.feeRange,
				latitude: parseFloat(localStorage.getItem('lat')),
				longitude: parseFloat(localStorage.getItem('lng'))
			}
			this.props.actions.getSpecialistList(tableObj);
			var country = localStorage.getItem('country_long') ? localStorage.getItem('country_long') : ''
			country = country.toLowerCase()
				.split(' ')
				.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
				.join(' ');
			let obj = {
				countryName: this.state.searchZipcode != '' ? this.state.countryName : localStorage.getItem('Currentcountry')
			}
			this.props.actions.listCurrencyFilter(obj)
			localStorage.setItem('zipcode', this.state.searchZipcode);
			localStorage.setItem('specializationId', this.state.specialization);
			localStorage.setItem('specializationName', this.state.specializationName);


		} else {
			toast.warning('Please select specialization or enter zipcode')
		}

	}

	componentWillMount() {


		// this.setState({ searchZipcode: localStorage.getItem('zipCode') })
		this.props.actions.getSpecializationList(this.props);

		var state = this.state;
		state.specialization = (state.specialization && state.specialization == '') ? state.specialization : localStorage.getItem('specializationId');

		state.specializationName = (state.specializationName && state.specializationName == '') ? state.specializationName : localStorage.getItem('specializationName');
		state.searchZipcode = (state.searchZipcode && state.searchZipcode == '') ? state.searchZipcode : localStorage.getItem('zipcode');
		var latt = parseFloat(localStorage.getItem('lat'));
		if (latt != parseFloat(0)) {
			state.searchMileDistance = 100;
		}

		if (this.state.isSearchHeader) {
			let tableObj = {
				searchSpecialization: this.state.specialization,
				searchZipcode: this.state.searchZipcode,
				searchMileDistance: this.state.searchMileDistance,
				searchGender: this.state.searchGender,
				searchRateValue: this.state.searchRateValue,
				searchDay: this.state.searchDay,
				feeRange: this.state.feeRange,
				count: this.state.count,
				page: this.state.activePage,
				latitude: parseFloat(localStorage.getItem('lat')),
				longitude: parseFloat(localStorage.getItem('lng'))
			}
			// console.log("body data==>", tableObj)
			// return;
			this.props.actions.getSpecialistList(tableObj);
		}
		state.countryName = localStorage.getItem('country_long') ? localStorage.getItem('country_long') : ''
		var country = localStorage.getItem('country_long') ? localStorage.getItem('country_long') : ''
		country = country.toLowerCase()
			.split(' ')
			.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
			.join(' ');
		this.setState(state);
		let obj = {
			countryName: country
		}
		this.props.actions.listCurrencyFilter(obj)
		this.isSearchingForDifferentLocation()



	}

	componentDidMount() {

		// this.setState({ isLoader: false });
		$("[data-widget='collapse']").click(function () {
			var box = $(this).parents(".box").first();
			var bf = box.find(".box-body, .box-footer");
			if (!$(this).children().hasClass("fa-plus")) {
				$(this).children(".fa-minus").removeClass("fa-minus").addClass("fa-plus");
				bf.slideUp();
			} else {
				$(this).children(".fa-plus").removeClass("fa-plus").addClass("fa-minus");
				bf.slideDown();
			}
		});
		var state = this.state;
		state.isLoader = false;

		state.searchZipcode = (state.searchZipcode && state.searchZipcode == '') ? state.searchZipcode : localStorage.getItem('zipcode');
		state.searchGender = (state.searchGender && state.searchGender != '') ? state.searchGender : localStorage.getItem('gender');
		state.searchMileDistance = (state.searchMileDistance && state.searchMileDistance != 0) ? state.searchMileDistance : parseInt(localStorage.getItem('mileDistance'));

		if (localStorage.getItem('fee1') && localStorage.getItem('fee1') == "true") {
			state.feeRange.push("100", "200");
		}
		if (localStorage.getItem('fee2') && localStorage.getItem('fee2') == "true") {
			state.feeRange.push("201", "500");
		} if (localStorage.getItem('fee3') && localStorage.getItem('fee3') == "true") {
			state.feeRange.push("500", "gt");
		}

		if (localStorage.getItem('zipcode') && localStorage.getItem('zipcode') != '') {
			state.narrowFilterZipCode = true;
		}
		// if (localStorage.getItem('specializationId') && localStorage.getItem('specializationId') != '') {

		// }
		if (localStorage.getItem('specializationId') && localStorage.getItem('specializationId') != '') {
			state.specializationName = localStorage.getItem('specializationName');
			state.specialization = localStorage.getItem('specializationId');

		}



		fee1Status = localStorage.getItem('fee1');
		fee2Status = localStorage.getItem('fee2');
		fee3Status = localStorage.getItem('fee3');
		day1Status = localStorage.getItem('fee1');
		day2Status = localStorage.getItem('fee2');
		day3Status = localStorage.getItem('fee3');
		day4Status = localStorage.getItem('fee3');

		var rateArray = [];
		var rateStr = localStorage.getItem('rateValue');
		rateArray = rateStr.split(',').map(Number).filter(Number);

		state.searchRateValue = rateArray;

		rateArray.forEach(function (item, index) {
			state["rate" + item + "Status"] = "true";

		});

		this.setState(state);

		// localStorage.setItem('specializationId', '');
		// localStorage.setItem('specializationName', '');
		// localStorage.setItem('zipcode', '');
		// localStorage.setItem('mileDistance', 0);
		localStorage.setItem('gender', '');
		localStorage.setItem('fee1', '');
		localStorage.setItem('fee2', '');
		localStorage.setItem('fee3', '');
		localStorage.setItem('day1', '');
		localStorage.setItem('day2', '');
		localStorage.setItem('day3', '');
		localStorage.setItem('day4', '');
		localStorage.setItem('rateValue', '');

		if (localStorage.getItem('mileDistance') == '101') {
			state.searchMileDistance = 101;
			state.countryName = localStorage.getItem('country_long')
		} else {
			state.searchMileDistance = parseFloat(localStorage.getItem('mileDistance'));

		}
		if (localStorage.getItem('mileDistance') == '0') {
			state.searchMileDistance = 0;
		}
		if (isNaN(state.searchMileDistance)) {
			state.searchMileDistance = 0;
		}
		let tableObj = {
			page: 1,
			count: 15,
			searchSpecialization: this.state.specialization,
			searchZipcode: this.state.searchZipcode,
			searchMileDistance: this.state.searchMileDistance,
			searchGender: this.state.searchGender,
			// countryName: this.state.countryName,
			searchDay: this.state.searchDay,
			searchRateValue: this.state.searchRateValue,
			feeRange: this.state.feeRange,
			latitude: parseFloat(localStorage.getItem('lat')),
			longitude: parseFloat(localStorage.getItem('lng'))
		}


		this.props.actions.getSpecialistList(tableObj);

	}
	componentWillReceiveProps(nextProps) {


		let currancy = nextProps.convertedCurrency ? parseFloat(nextProps.convertedCurrency.result).toFixed(2) : '';

		if (currancy && this.state.currencyConversion) {
			this.setState({ currencyConversion: false })
			confirmAlert({
				customUI: ({ onClose }) => {
					return (
						<div className='custom-ui'>
							<a style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>

							<h1>Currency Exchange Rate</h1>
							<p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p>
							<span>The exchange rate is just for reference and is an estimate.The actual amount charged will be dependent on the payment gateway and the exchange rate used by them at the point of payment</span>

						</div>
					)
				}
			})
		}
		var state = this.state;
		state.listcurrencyFilter = nextProps.listcurrencyFilter ? nextProps.listcurrencyFilter[0] : state.listcurrencyFilter,
			state.toRange1.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV1 : state.toRange1.value,
			state.fromRange1.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV2 : state.fromRange1.value,
			state.toRange2.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV3 : state.toRange2.value,
			state.fromRange2.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV4 : state.fromRange2.value,
			state.toRange3.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV5 : state.toRange3.value,
			state.fromRange3.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV6 : state.fromRange3.value,
			state.currencyConversion = false;
		this.setState(state);
		console.log(currancy);

		this.setState({
			isReady: false,
			isSearch: false,
			localCurrency: nextProps.convertedCurrency ? '≈ ' + currancy + ' ' + localStorage.getItem('currency') : '',
			specialistList: nextProps.specialistList,

			specializationList: (nextProps.specializationList && nextProps.specializationList.length > 0) ? nextProps.specializationList : this.state.specializationList,
			// nextProps.specializationList,
			totalCount: nextProps.totalCount
		})
		// debugger;
		localStorage.setItem('country_long', nextProps.specialistList.specialistRecord && nextProps.specialistList.specialistRecord.length > 0 ? nextProps.specialistList.specialistRecord[0].country : '')

		localStorage.setItem('FintercurrencySymbol', nextProps.specialistList.specialistRecord && nextProps.specialistList.specialistRecord.length > 0 ? nextProps.specialistList.specialistRecord[0].currencySymbol : '')

		// if (validator.isValid(nextProps.searchkey)) {
		if (nextProps.searchkey) {
			if (nextProps.searchkey.searchSpecialization || nextProps.searchkey.searchSpecialization == "") {

				this.setState({
					specialization: nextProps.searchkey.searchSpecialization, isSearch: false, isSearchHeader: true,
					specializationName: nextProps.searchkey.searchSpecializationName,
					specialistList: nextProps.specialistList,
					specializationList: nextProps.specializationList,
					totalCount: nextProps.totalCount
				})
			}
			if (nextProps.searchkey.searchZipcode || nextProps.searchkey.searchZipcode == "") {
				this.setState({
					searchZipcode: nextProps.searchkey.searchZipcode, isSearch: false, isSearchHeader: true,
					specialistList: nextProps.specialistList,
					specializationList: nextProps.specializationList,
					totalCount: nextProps.totalCount
				})
			}

		}
		if (nextProps.specialistList.specialistRecord && nextProps.specialistList.specialistRecord.length == 0) {
			this.setState({ narrowFilter: false, narrowFilterZipCode: false })
		}
		if (nextProps.questionRatings != undefined) {
			this.setState({
				questionRatings: (nextProps.questionRatings && nextProps.questionRatings.avgQuttionsRating.length > 0) ? nextProps.questionRatings.avgQuttionsRating : []
			})
		}
		this.setState({
			otherConsultationAddress: (nextProps.otherConsultationAddress ? nextProps.otherConsultationAddress.specialistRecord : []),
			otherMilesDistance: (nextProps.otherConsultationAddress ? nextProps.otherConsultationAddress.arraymiles : []),
		})

	}
	goToCalendarPageFromOtherConsulatation(availId, index) {
		localStorage.availabilityId = availId;
		let specialistData = this.state.otherConsultationAddress[index].data;
		//
		// localStorage.availabilityId = specialistData.avId;
		localStorage.clinicCountryZone = specialistData.contryzone;
		localStorage.setItem('clinicCountryZone', specialistData.contryzone);
		localStorage.setItem('doctorAddress', specialistData.addressLineOne + ', ' + specialistData.city + ', ' + specialistData.country)

		this.props.history.push('/dashboard/book-appointment-calendar');
	};

	goToCalendarPage(index) {
		let specialistData = this.state.specialistList.specialistRecord[index];

		localStorage.availabilityId = specialistData.avId;
		// localStorage.clinicCountryZone = specialistData.contryzone;
		localStorage.setItem('clinicCountryZone', specialistData.contryzone);
		localStorage.setItem('doctorAddress', specialistData.addressLineOne + ', ' + specialistData.city + ', ' + specialistData.country)

		this.props.history.push('/dashboard/book-appointment-calendar');
	};
	goToDetailsPage(index, doctorId) {
		console.log("sssssssssssss", doctorId)
		let specialistData = this.state.specialistList.specialistRecord[index];
		localStorage.setItem('clinicCountryZone', specialistData.contryzone);

		console.log("specialistData", specialistData);
		var state = this.state;
		localStorage.setItem("specializationId", state.specialization);
		localStorage.setItem('specializationName', this.state.specializationName);

		localStorage.setItem('zipcode', this.state.searchZipcode);
		localStorage.setItem('mileDistance', this.state.searchMileDistance);
		localStorage.setItem('gender', this.state.searchGender);

		if (this.state.feeRange.includes("100")) {
			localStorage.setItem('fee1', "true");
		}
		if (this.state.feeRange.includes("201")) {
			localStorage.setItem('fee2', "true");
		}
		if (this.state.feeRange.includes("501")) {
			localStorage.setItem('fee3', "true");
		}

		var arrayRate = this.state.searchRateValue;
		var str = '';
		arrayRate.forEach(function (item, index) {
			str = str + item + ',';
			localStorage.setItem('rateValue', str);

		});
		if (specialistData.doctorId)
			localStorage.setItem('specialistId', specialistData.doctorId);
		else
			localStorage.setItem('specialistId', doctorId);

		this.props.history.push('/dashboard/specialist-details/' + specialistData.avId);
	};

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let tableObj = {
			searchSpecialization: this.state.specialization,
			searchZipcode: this.state.searchZipcode,
			searchMileDistance: this.state.searchMileDistance,
			searchGender: this.state.searchGender,
			searchRateValue: this.state.searchRateValue,
			searchDay: this.state.searchDay,
			feeRange: this.state.feeRange,
			count: this.state.count,
			page: pageNumber,
			latitude: parseFloat(localStorage.getItem('lat')),
			longitude: parseFloat(localStorage.getItem('lng'))
		}
		this.props.actions.getSpecialistList(tableObj);
	}

	Capitalize(str) {
		if (str != '' && str != undefined)
			return str.charAt(0).toUpperCase() + str.slice(1);
		else
			return '';
	}
	rebbonClick(index, e) {
		if (index == 'close') {
			this.setState({ rebbon: false })
		}
		else {
			this.setState({ rebbon: "RebbonPopup" + index })
		}
	}

	isSearchingForDifferentLocation = () => {
		let searchZipcode = localStorage.getItem("country_long") ? localStorage.getItem("country_long").toLowerCase() : 'India';
		let currentCountry = localStorage.getItem("localityCountry") ? localStorage.getItem("localityCountry").toLowerCase() : 'India';
		// let 
		console.log("localistcour==", searchZipcode == currentCountry)
		return searchZipcode == currentCountry;
		// let userlocation = momentTz.tz.guess()
		// let latitude = parseFloat(localStorage.getItem('lat'));
		// let longitude = parseFloat(localStorage.getItem('lng'));
		// let searchedTimeZone = geoTz(latitude, longitude);
		// var tz = zipcode_to_timezone.lookup("TW76HA");
		// console.log("searchZIpcode", searchZipcode,tz); // America/Los_Angeles
		// console.log("===>>", userlocation, searchedTimeZone)

	}

	render() {

		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
		var filtercurrencysymbol = localStorage.getItem('FintercurrencySymbol')
		var isReady = this.state.isReady;
		var sel = this.state.specialization;
		var specialistList = this.state.specialistList.specialistRecord ? this.state.specialistList.specialistRecord : [];
		var specializationList = this.state.specializationList;
		var message = (specialistList.length == 0) ? (isReady ? 'Ready to search' : '0 Results') : (isReady ? 'Ready to search' : specialistList.length + ' Results ');
		if (this.state.specialization && specializationList && specializationList.length > 0) {
			if (this.state.specializationName == "" || this.state.specializationName == undefined) {
				for (var i = 0; specializationList.length > i; i++) {
					if (specializationList[i]._id == this.state.specialization) {
						message = message + ' for ' + specializationList[i].specialization
					}

				}
			} else {
				message = message + ' for ' + this.state.specializationName

			}
		}
		if (this.state.searchZipcode) {
			message = message + ' near ' + this.state.searchZipcode
		}
		var questar = [];
		{
			this.state.questionRatings.length >= 0 ? this.state.questionRatings.forEach(function (item, index) {
				var queRating = [];
				for (var i = 0; i < Math.round(item.avgRate); i++) {
					queRating.push(<a href="#" className="reviewsStarDd"><i className="fa fa-star "></i></a>)
				}
				for (var j = 0; j < (5 - Math.round(item.avgRate)); j++) {
					queRating.push(<a href="#" className="reviewsStarDd reviewsStarDdGray"><i className="fa fa-star "></i></a>)
				}
				questar.push(
					<li>{item.ratingqs}
						<p>	{queRating}</p>
					</li>


				)
			}.bind(this))
				: ""
		}
		console.log(">>>>>>>>>>>>>>>>>>>>>>", this.state)
		return (

			<div className="content-wrapper">

				{this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :

					<section className="content container-fluid book-appointement-ipad">
						{/* <ToastContainer /> */}
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li ><Link href="#tab_1" data-toggle="tab" className="active show">Search Specialist</Link></li>
											<li className=" col-md">
												<div className="content-header"><ol className="breadcrumb">
													<li><Link> Book Appointment</Link></li>
													<li className="active">Search Specialist</li>
												</ol></div>

											</li>
										</ul>
										<div className="row">
											<div className="col-md-5 col-lg-4 col-xl-3  active">
												<div className="tab-content tabother searchSpe collapResults">
													<div className="tab-pane active" >
														<div className="form-group">
															<h2><i className="fa fa-filter"></i> Narrow your Results </h2>
														</div>
														<div className="box">
															<div className="box-header " onClick={this.filterColapsableClickedDistance}>
																<h3 className="box-title"><i><img src={require('../../images/img/distance_icon.png')} alt="" /></i>Distance</h3>
																<div className="box-tools pull-right">
																	<button type="button" className="btn btn-box-tool" data-widget="collapse"><i className={this.state.filterColapsableDistance === true ? "fa fa-minus" : "fa fa-plus"}></i> </button>
																</div>
															</div>
															{this.state.filterColapsableDistance ? <div className="box-body">
																<div className="form-group">
																	<select value={this.state.searchMileDistance} className="form-control" name="searchMileDistance" onChange={this.onNarrowChange.bind(this)}>
																		<option value="0">Select Distance </option>
																		{(constant.DISTANCE.length) > 0 ? constant.DISTANCE.map((option, index) => <option value={option.id} key={index}>{option.value}</option>) : 'd'}</select>
																</div>
															</div> : null}
														</div>
														<div className="box" >
															<div className="box-header " onClick={this.filterColapsableClickedPatientReviews}>

																<h3 className="box-title"><i><img src={require('../../images/img/patient_peviews_icons.png')} alt="" /></i>PATIENT REVIEWS</h3>
																<div className="box-tools pull-right">
																	<button type="button" className="btn btn-box-tool" data-widget="collapse"><i className={this.state.filterColapsablePatientReviews === true ? "fa fa-minus" : "fa fa-plus"}></i> </button>
																</div>
															</div>

															{this.state.filterColapsablePatientReviews ? <div className="box-body">
																<div className="checkbox checkbox-primary">
																	{this.state.rate5Status ? <input type="checkbox" id="ratingCheckbox5" onChange={this.onNarrowChange.bind(this)} name="searchRateValue" value="5" onChange={this.onNarrowChange} checked /> : <input type="checkbox" id="ratingCheckbox5" onChange={this.onNarrowChange.bind(this)} name="searchRateValue" value="5" onChange={this.onNarrowChange}
																	//  disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																	/>}



																	<label htmlFor="ratingCheckbox5" className="startReview">
																		{/* <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i>  */}
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																	</label>
																</div>

																<div className="checkbox checkbox-primary">
																	{this.state.rate4Status ? <input type="checkbox" onChange={this.onNarrowChange.bind(this)} name="searchRateValue" id="ratingCheckbox4" value="4" checked /> :
																		<input type="checkbox" onChange={this.onNarrowChange.bind(this)} name="searchRateValue" id="ratingCheckbox4" value="4"

																		// disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																		/>
																	}
																	<label htmlFor="ratingCheckbox4" className="startReview">
																		{/* <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-gray"></i>  */}
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																	</label>
																</div>

																<div className="checkbox checkbox-primary">
																	{this.state.rate3Status == "true" ? <input type="checkbox" onChange={this.onNarrowChange.bind(this)} name="searchRateValue" id="ratingCheckbox3" value="3" checked /> : <input type="checkbox" onChange={this.onNarrowChange.bind(this)} name="searchRateValue" id="ratingCheckbox3" value="3"
																	//  disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																	/>}

																	<label htmlFor="ratingCheckbox3" className="startReview">
																		{/* <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-gray"></i> <i className="fa fa-star text-gray"></i> */}
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																	</label>
																</div>

																<div className="checkbox checkbox-primary">
																	{this.state.rate2Status ? <input type="checkbox" name="searchRateValue" onChange={this.onNarrowChange.bind(this)} id="ratingCheckbox2" value="2" checked /> :
																		<input type="checkbox" name="searchRateValue" onChange={this.onNarrowChange.bind(this)} id="ratingCheckbox2" value="2"
																		//  disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																		/>
																	}

																	<label htmlFor="ratingCheckbox2" className="startReview">
																		{/* <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-gray"></i> <i className="fa fa-star text-gray"></i> <i className="fa fa-star text-gray"></i>  */}
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																	</label>
																</div>

																<div className="checkbox checkbox-primary">
																	{this.state.rate1Status ? <input type="checkbox" onChange={this.onNarrowChange.bind(this)} name="searchRateValue" id="ratingCheckbox1" value="1" checked /> :
																		<input type="checkbox" onChange={this.onNarrowChange.bind(this)} name="searchRateValue" id="ratingCheckbox1" value="1"
																		// disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																		/>}
																	<label htmlFor="ratingCheckbox1" className="startReview">
																		{/* <i className="fa fa-star text-yellow"></i> <i className="fa fa-star text-gray"></i> <i className="fa fa-star text-gray"></i> <i className="fa fa-star text-gray"></i> <i className="fa fa-star text-gray"></i>  */}
																		<img className="rateStarSize" src={require('../../images/start_icon.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																		<img className="rateStarSize" src={require('../../images/start_icon_off.png')} />
																	</label>
																</div>
															</div> : null}
														</div>
														{this.isSearchingForDifferentLocation() ?

															<div className="box">
																<div className="box-header " onClick={this.filterColapsableClickedAvailability}>
																	<h3 className="box-title"><i><img src={require('../../images/img/availability_icon.png')} alt="" /></i>AVAILABILITY</h3>
																	<div className="box-tools pull-right">
																		<button type="button" className="btn btn-box-tool" data-widget="collapse"><i className={this.state.filterColapsableAvailability === true ? "fa fa-minus" : "fa fa-plus"}></i> </button>
																	</div>
																</div>
																{this.state.filterColapsableAvailability ? <div className="box-body">
																	{this.state.day1Status && this.state.day1Status == "true" ?
																		< div className="checkbox checkbox-primary" >
																			<input type="checkbox" onChange={this.onNarrowChange} name="searchDay" id="dayValue1" value="Today" checked />
																			<label htmlFor="dayValue1" className="startReview">Today
 																	</label>
																		</div> : < div className="checkbox checkbox-primary" >
																			<input type="checkbox" onChange={this.onNarrowChange} name="searchDay" id="dayValue1" value="Today"
																			// disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																			/>
																			<label htmlFor="dayValue1" className="startReview">Today
 																	</label>
																		</div>
																	}

																	{this.state.day2Status && this.state.day2Status == "true" ?
																		<div className="checkbox checkbox-primary">
																			<input type="checkbox" name="searchDay" id="dayValue2" onChange={this.onNarrowChange} value="Tomorrow" checked />
																			<label htmlFor="dayValue2" className="startReview">Tomorrow
																	</label>
																		</div> : <div className="checkbox checkbox-primary">
																			<input type="checkbox" name="searchDay" id="dayValue2" onChange={this.onNarrowChange} value="Tomorrow"
																			// disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																			/>
																			<label htmlFor="dayValue2" className="startReview">Tomorrow
																	</label>
																		</div>
																	}

																	{this.state.day3Status && this.state.day3Status == "true" ? <div className="checkbox checkbox-primary">
																		<input type="checkbox" name="searchDay" id="dayValue3" onChange={this.onNarrowChange} value="All" checked />
																		< label htmlFor="dayValue3" className="startReview">Next two weeks </label>
																	</div> :
																		<div className="checkbox checkbox-primary">
																			<input type="checkbox" name="searchDay" id="dayValue3" onChange={this.onNarrowChange} value="All"
																			//  disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																			/>
																			<label htmlFor="dayValue3" className="startReview">Next two weeks </label>
																		</div>}
																	{this.state.day4Status && this.state.day4Status == "true" ? <div className="checkbox checkbox-primary">
																		<input type="checkbox" name="searchDay" id="dayValue4" onChange={this.onNarrowChange} value="All30" checked />
																		< label htmlFor="dayValue4" className="startReview">Next 30 weeks </label>
																	</div> :
																		<div className="checkbox checkbox-primary">
																			<input type="checkbox" name="searchDay" id="dayValue4" onChange={this.onNarrowChange} value="All30"
																			//  disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																			/>
																			<label htmlFor="dayValue4" className="startReview">Next 30 days </label>
																		</div>}
																</div> : null}
															</div>
															: ''}





														<div className="box">
															<div className="box-header " onClick={this.filterColapsableClickedConsultationfees}>
																<h3 className="box-title"><i><img src={require('../../images/img/consultation_fees_icons.png')} alt="" /></i>Consultation fees</h3>
																<div className="box-tools pull-right">
																	<button type="button" className="btn btn-box-tool" data-widget="collapse"><i className={this.state.filterColapsableConsultationfees === true ? "fa fa-minus" : "fa fa-plus"}></i> </button>
																</div>
															</div>
															{this.state.filterColapsableConsultationfees ? <div className="box-body">
																{this.state.fee1Status && this.state.fee1Status == "true" ? < div className="checkbox checkbox-primary" >
																	<input checked type="checkbox" onChange={this.onNarrowChange.bind(this)} name="fee" id="feeValue1" value={this.state.toRange1.value} />
																	<label htmlFor="feeValue1" className="startReview">{this.state.listcurrencyFilter && this.state.listcurrencyFilter.countryAbbreviation ? this.state.listcurrencyFilter.countryAbbreviation : ''} {this.state.toRange1.value} - {this.state.fromRange1.value}
																	</label>
																</div> : < div className="checkbox checkbox-primary" >
																		<input type="checkbox" onChange={this.onNarrowChange.bind(this)} name="fee" id="feeValue1" value={this.state.toRange1.value}
																		// disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																		/>
																		<label htmlFor="feeValue1" className="startReview">{this.state.listcurrencyFilter && this.state.listcurrencyFilter.countryAbbreviation ? this.state.listcurrencyFilter.countryAbbreviation : ''} {this.state.toRange1.value} - {this.state.fromRange1.value}
																		</label>
																	</div>}

																{this.state.fee2Status && this.state.fee2Status == "true" ? <div className="checkbox checkbox-primary">
																	<input type="checkbox" name="fee" id="feeValue2" onChange={this.onNarrowChange} value={this.state.toRange2.value} checked />
																	<label htmlFor="feeValue2" className="startReview">{this.state.listcurrencyFilter && this.state.listcurrencyFilter.countryAbbreviation ? this.state.listcurrencyFilter.countryAbbreviation : ''} {this.state.toRange2.value} - {this.state.fromRange2.value}
																	</label>
																</div> : <div className="checkbox checkbox-primary">
																		<input type="checkbox" name="fee" id="feeValue2" onChange={this.onNarrowChange} value={this.state.toRange2.value}
																		// disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																		/>
																		<label htmlFor="feeValue2" className="startReview">{this.state.listcurrencyFilter && this.state.listcurrencyFilter.countryAbbreviation ? this.state.listcurrencyFilter.countryAbbreviation : ''} {this.state.toRange2.value} - {this.state.fromRange2.value}
																		</label>
																	</div>}

																{this.state.fee3Status && this.state.fee3Status == "true" ? <div className="checkbox checkbox-primary">
																	<input type="checkbox" name="fee" id="feeValue3" onChange={this.onNarrowChange} value={this.state.toRange3.value} checked />
																	< label htmlFor="feeValue3" className="startReview">{this.state.listcurrencyFilter && this.state.listcurrencyFilter.countryAbbreviation ? this.state.listcurrencyFilter.countryAbbreviation : ''} > {this.state.fromRange2.value} </label>
																</div> :
																	<div className="checkbox checkbox-primary">
																		<input type="checkbox" name="fee" id="feeValue3" onChange={this.onNarrowChange} value={this.state.toRange3.value}
																		//  disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																		/>
																		<label htmlFor="feeValue3" className="startReview">{this.state.listcurrencyFilter && this.state.listcurrencyFilter.countryAbbreviation ? this.state.listcurrencyFilter.countryAbbreviation : ''} > {this.state.fromRange2.value} </label>
																	</div>}
															</div> : null}
														</div>
														<div className="box">
															<div className="box-header " onClick={this.filterColapsableClickedGender}>
																<h3 className="box-title"><i><img src={require('../../images/img/gender_icon.png')} alt="" /></i>Gender</h3>
																<div className="box-tools pull-right">
																	<button type="button" className="btn btn-box-tool" data-widget="collapse"><i className={this.state.filterColapsableGender === true ? "fa fa-minus" : "fa fa-plus"}></i> </button>
																</div>
															</div>
															{this.state.filterColapsableGender ? <div className="box-body">
																<div className="form-group">
																	<select className="form-control" name="searchGender" value={this.state.searchGender} onChange={this.onNarrowChange.bind(this)}
																	// disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																	>
																		<option value="">Select Gender </option>
																		{(constant.GENDER.length) > 0 ? constant.GENDER.map((option, index) => <option value={option.id} key={index}>{option.value}</option>) : ''}</select>
																</div>
															</div> : null}
														</div>
														<div className="box">
															<div className="box-header " onClick={this.filterColapsableClickedLanguage}>
																<h3 className="box-title"><i><img src={require('../../images/img/language_icon.jpg')} alt="" /></i>Language</h3>
																<div className="box-tools pull-right">
																	<button type="button" className="btn btn-box-tool" data-widget="collapse"><i className={this.state.filterColapsableLanguage === true ? "fa fa-minus" : "fa fa-plus"}></i> </button>
																</div>
															</div>
															{this.state.filterColapsableLanguage ? <div className="box-body">
																<div className="form-group">
																	<select className="form-control" name="searchLanguage" value={this.state.searchLanguage} onChange={this.onNarrowChange.bind(this)}
																	// disabled={!this.state.narrowFilter && (specialistList == undefined || (specialistList && specialistList.length == 0))}
																	>
																		<option value="">Select Language </option>
																		{(constant.LANGUAGE.length) > 0 ? constant.LANGUAGE.map((option, index) => <option value={option.id} key={index}>{option.value}</option>) : ''}</select>
																</div>
															</div> : null}
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-7 col-lg-8 col-xl-9">
												<div className="tab-content tabother ">
													<div className="row">
														<div className="col-md-12">
															<div className="searchBoxRes ">
																<div className="row">
																	<div className="col-md-12 col-lg-12 col-xl-5">
																		<div className="boxMrgB">
																			<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/family_medicine.png')} alt="" /></i></span>

																				{this.state.specialization && this.state.specialization != '' ?
																					<Typeahead
																						onChange={(selected) => {
																							this.setState({
																								isReady: true,
																								specializationName: (selected && selected.length > 0) ? selected[0].label : '',
																								specialization: (selected && selected.length > 0) ? selected[0].id : ''
																							});
																						}}
																						id="typeahead"
																						labelKey="label"
																						options={specializationList ? specializationList : []}
																						defaultValue={this.state.specialization}
																						defaultSelected={[{ id: this.state.specialization, label: this.state.specializationName }]}
																					/>
																					: <Typeahead
																						onChange={(selected) => {
																							this.setState({
																								isReady: true,
																								specializationName: (selected && selected.length > 0) ? selected[0].label : '',
																								specialization: (selected && selected.length > 0) ? selected[0].id : ''
																							});
																						}}
																						options={specializationList ? specializationList : []}
																						defaultValue={this.state.specialization}
																						//defaultSelected={[{ id: this.state.specialization, label: this.state.specializationName }]}
																						placeholder="Search Speciality"
																					/>
																				}


																			</div>
																		</div>
																	</div>
																	<div className="col-md-12 col-lg-12 col-xl-5">
																		<div className="boxMrgB">
																			<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/map_icon.png')} alt="" /></i></span>
																				{/* <input type="text" name="searchZipcode" className="form-control" onChange={this.onChange.bind(this)} value={this.state.searchZipcode} placeholder={localStorage.getItem('lat')&& localStorage.getItem('lng')?"Current Location":"Near City, Zipcode"} /> */}
																				<Autocomplete
																					id='autocomplete'
																					className="form-control cityinput"
																					data-toggle="tooltip"
																					data-placement="right"
																					title="Country, State and City will be automatically filled"
																					id="inputAddress2"
																					placeholder="Near City, Zip Code"
																					name="searchZipcode"
																					value={this.state.searchZipcode} onChange={this.onChange.bind(this)}
																					onPlaceSelected={this.updateAddress}
																					types={['(regions)']}
																				// autoComplete="off"
																				// {...fields}

																				/>
																			</div>
																		</div>
																	</div>
																	<div className="col-md-12 col-lg-12 col-xl-2">
																		<div className="boxMrgB">
																			<button type="button" onClick={this.search.bind(this)} className="btn btn-block btn-warning btn-lg" disabled={this.state.isSearch}>Search {this.state.spinner && this.state.isSearch ? <i className="fa fa-spinner fa-spin Searchloader" /> : ""}</button>
																		</div>
																	</div>
																</div>
																<div className="col-md-12">
																	<p>{message}
																		{/* {specialistList && specialistList.length > 0 ? specialistList.length + ' Results ' : ''} {this.state.specializationName != undefined || this.state.specializationName != '' ? 'for ' + this.state.specializationName : ''} {this.state.searchZipcode !== undefined ? 'near ' + this.state.searchZipcode : ''} */}
																	</p>
																</div>
															</div>
															<div>
																{/* {this.state.sortNameDistance || this.state.sortNameRating ||this.state.sortNameConsultationFees || this.state.sortNameGender ? <div> */}
																{this.state.searchMileDistance || this.state.searchRateValue || this.state.searchGender || this.state.feeRange ?
																	<div>
																		<p> Sorted By
                          <strong>	{this.state.searchMileDistance && this.state.searchMileDistance != '0' ? "Distance" : null}</strong>


																			<strong>		{(this.state.searchRateValue && this.state.searchRateValue.length > 0) && (this.state.searchMileDistance && this.state.searchMileDistance != '0') ? "," : null}</strong>

																			<strong>		{this.state.searchRateValue && this.state.searchRateValue.length > 0 ? "Rating " : null}

																			</strong>

																			<strong>		{(this.state.searchDay && this.state.searchDay.length > 0) && (this.state.searchRateValue && this.state.searchRateValue.length > 0)
																				||
																				(this.state.searchDay && this.state.searchDay.length > 0) && (this.state.searchMileDistance && this.state.searchMileDistance != '0') ? "," : null}</strong>

																			<strong>		{this.state.searchDay && this.state.searchDay.length > 0 ? "Availability " : null}

																			</strong>



																			<strong>	{
																				(this.state.feeRange && this.state.feeRange.length) && (this.state.searchMileDistance && this.state.searchMileDistance != '0')
																					|| (this.state.feeRange && this.state.feeRange.length) && (this.state.searchRateValue && this.state.searchRateValue.length > 0)
																					|| (this.state.feeRange && this.state.feeRange.length) && (this.state.searchDay && this.state.searchDay.length > 0) > 0 ? "," : null}</strong>
																			<strong>	{this.state.feeRange && this.state.feeRange.length > 0 ? "Consultation Fees " : null}</strong>


																			<strong>	{(this.state.searchGender && this.state.searchGender != "") && (this.state.searchRateValue && this.state.searchRateValue.length > 0) || (this.state.searchGender && this.state.searchGender != "") && (this.state.searchMileDistance && this.state.searchMileDistance != '0')
																				|| (this.state.searchDay && this.state.searchDay.length > 0) && (this.state.searchGender && this.state.searchGender != "")
																				|| (this.state.feeRange && this.state.feeRange.length > 0) && (this.state.searchGender && this.state.searchGender != "") ? "," : null}</strong>

																			<strong>	{this.state.searchGender && this.state.searchGender != "" ? "Gender " : null}</strong>







																		</p>
																		{/* {this.state.sortNameDistance !=null ? this.state.sortNameDistance : '' }{this.state.sortNameRating !=null ? `, ${this.state.sortNameRating}` : ''}</strong></p> */}

																	</div> : null
																}
															</div>
															{specialistList ? specialistList.length > 0 ? specialistList.map((item, index) =>

																<div className="searchList  listings" key={index} >
																	<div className="searchImg">

																		{(item.specialists && item.specialists.profileImage) == constant.DEFAULT_USER_IMAGE ? <img className="profile-user-img img-responsive img-circle" src={item.users && item.users[0].gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png'} alt="User profile picture" /> : <img className="profile-user-img img-responsive img-circle" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + (item.users ? item.users[0]._id : '') + '/' + item.specialists.profileImage} alt="User profile picture" onError={e => {
																			e.target.src = defaultImagePath;
																		}} />}
																		<div className="ribbonIcon">
																			<div className="btn-group">
																				<div className=" dropdown-toggle" style={{ 'cursor': 'pointer' }} onClick={this.rebbonClick.bind(this, index)}>
																					<img src={require('../../images/img/ribbon_icon.png')} />
																				</div>
																				<div id={"RebbonPopup" + index}
																					className={this.state.rebbon == 'RebbonPopup' + index ? "dropdown-menu show" : "dropdown-menu"}
																				// className= "dropdown-menu"
																				>
																					<Link onClick={this.rebbonClick.bind(this, 'close')} style={{ cursor: "pointer" }} className="closeBtn"></Link>
																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Experience Summary
			</Link>
																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Address
		</Link>
																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Academics
		</Link>

																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Identification </Link>
																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Certifications  </Link>
																				</div>
																			</div>
																		</div>
																	</	div>

																	<div className="row search-padding">
																		<div className="col-md-12 col-sm-4 col-lg-4 tspBoxBrorder" >
																			<h3 className="profile-username text-capitalize" style={{ cursor: 'pointer' }}
																				onClick={this.goToDetailsPage.bind(this, index, item.users[0]._id)}>Dr. {this.Capitalize(item.users[0].firstName)} {this.Capitalize(item.users[0].lastName)}</h3>
																			<h4 className="profile-dr">{item.specializations.specialization} | {item.users[0].gender}</h4>
																			<h4 className="profile-dr">{item.specialists.qualification}</h4>

																			<div className="reviewsStarDd"><StarRatingComponent
																				name="rate2"
																				editing={false}
																				starCount={5}
																				emptyStarColor={'#D3D3D3'}
																				renderStarIcon={(index, value) => {
																					return (
																						<span>
																							{index <= value ? <span><img src={require('../../images/start_icon.png')} /></span> : <span><img src={require('../../images/start_icon_off.png')} /></span>}
																						</span>
																					);
																				}}
																				value={Math.round(item.averageRating)}
																			/>
																				<div className="btn-group show">
																					<Link style={{ 'cursor': 'pointer' }} onClick={this.reviewCount.bind(this, index, item._id)} className="reviewCount  dropdown-toggle reviewCountPosition" aria-haspopup="true" aria-expanded="false">
																						({item ? item.reviewCount : 0})</Link>

																					<div id={'feedbackPopup' + index} className={this.state.reviewCountClicked == 'feedbackPopup' + index ? "dropdown-menu show " : "dropdown-menu "}>
																						<Link onClick={this.reviewCount.bind(this, 'close')} style={{ cursor: "pointer" }} className="closeBtn"></Link> < br />
																						<ul>
																							{questar.length > 0 ? questar
																								: <div className="text-center"> No Feedback Yet</div>

																							}
																						</ul>
																					</div>
																				</div>

																			</div>




																			<p className="expInfo">{item.specialists.yearExperience > 0 ? item.specialists.yearExperience + ' year(s)' : ''}  {item.specialists.monthExperience > 0 ? item.specialists.monthExperience + ' month(s)' : ''}  experience</p>

																			{item.mobileNo != '' && item.mobileNo != null ? <p className="phoneInfo">
																				<span className="mobileicon"><i className="fa fa-phone"></i></span><span className="displaytablephn"><Link> {item.phoneCode1}- {item.mobileNo}</Link></span>

																			</p> : ""}
																			{item.telephoneNo != "" && item.telephoneNo != null ? <p className="phoneInfo mobileIcon">
																				<span className="mobileicon">		<i className="fa fa-mobile"> </i> </span> <span className="displaytablephn"><Link> {item.phoneCode2}- {item.telephoneNo}</Link></span>
																			</p> : ""}
																		</div>
																		<div className="col-md-12 col-sm-4 col-lg-4 tspBoxBrorder">
																			<ul className="iconhirarchiaddrss marginZero">
																				<li className="font-icon-size">	<i className="fa fa-home" aria-hidden="true"></i></li>
																				<li>	{item.clinicName}</li>
																			</ul>
																			<ul>
																				<li> <i className="fa fa-map-marker"></i></li>
																				<li className="capitalized_txt" style={{ 'wordBreak': 'break-all' }}><p>{item.addressLineOne},</p>
																					<p>{item.city}{item.city ? ',' : ''}</p>
																					<p>	{item.state},</p>
																					<p>{item.country},</p>
																					<p>	{item.zipCode}</p></li>
																				{item.distcalculated ? <a href="javascript:void(0)" className="milesAwayMargin">{item.distcalculated.toFixed(2)} miles away</a> : ''}
																			</ul>
																			{item.specialists.isMultipleAvailiability == true ? <div className="consultation" ><button type="button" className="btn btn-block btn-default btn-sm" onClick={this.getOtherConsultationAddress.bind(this, item.users[0]._id, item._id, index)}>Other Consultation Addresses</button></div> : ''}
																		</div>
																		<div className="col-md-12 col-sm-4 col-lg-4 text-center">
																			<div className="apt-btn-aln">
																				<button type="button" onClick={this.goToCalendarPage.bind(this, index)} className="btn btn-block btn-warning btn-sm requestApp" style={{ 'height': '60px', 'paddingTop': '7px' }}><i className=" fa-calendar-check-o fa"></i>Request<br />
																					Appointment</button>
																				{/* <p style={{ whiteSpace: "nowrap" }}>Consultation Fees : {item.fee} {item.currencySymbol}</p> */}

																				<p className="consultationFeesLayout" >
																				<span><i className="fa"><img src={require('../../images/consultationfees_icon.png')} /></i></span>
																				<div>Consultation Fees<span onClick={this.currencyApi.bind(this, item.currencySymbol, item.fee)}>{item.fee} {item.currencySymbol}</span></div></p>
																				<div className="col-sm-4 col-md-12 col-lg-12 bookAppoinmentLanguageInfo">
																					<div className='row'>
																						<div className="col-sm-2"><i className="languageIcon"><img src={require('../../images/img/language_icon.jpg')} alt="" /></i>
																						</div>
																						<div className="col-md-auto">	<p className="expInfo">Languages Spoken</p>
																						</div>
																					</div>
																				</div>
																				<div className="col-sm-4 col-md-12 col-lg-12  languageList">
																					<p className="capitalized_txt languageTxt">Hindi, English, Bengali</p>
																				</div>
																			</div>
																		</div>
																	</div>


																	<div className="popUpList popUpReq" id={"addressPopUp" + index}>
																		<h5 className="heading-mediumfont"> Select Address </h5>
																		<Link onClick={this.hideAddressPopUp.bind(this, index)} style={{ cursor: "pointer" }} className="closeBtn"></Link>
																		{this.state.isLoading ? <div className="loaderCenter"><ReactLoading type={'bars'} color={'blue'} /></div> :
																			<div className="popUpListInfo">
																				<ul>
																					{this.state.otherConsultationAddress ? this.state.otherConsultationAddress.map((option, indexs) =>
																						<div key={indexs} /*style={{ marginTop: 25 }}*/>
																							<li><i className="fa fa-home" aria-hidden="true"></i></li>
																							<li className="clinic-name-bold">{option.data.clinicName}</li>
																							<li> <i className="fa fa-map-marker"></i></li>
																							<li className="capitalized_txt"> <p>{option.data.addressLineOne},</p>
																								<p>{option.data.city},</p>
																								<p>	{option.data.state},</p>
																								<p>{option.data.country},</p><p>{option.data.zipCode}</p>
																								<div className='miles-consultation-right'>
																									<p> {this.state.otherMilesDistance ? <a href="javascript:void(0)">{this.state.otherMilesDistance[indexs].toFixed(2)} miles away</a> : ''}</p>

																								</div>																		{/* <Link className="milesAway">3 miles away</Link> */}
																							</li>
																							{option.data.mobileNo != null ? <li> <i className="fa"><i className="fa fa-phone phn-margin"></i></i></li> : ''}
																							{option.data.mobileNo != null ? <li className="phoneInfo"><Link>{option.data.mobileNo ? option.data.phoneCode1 : ''}- {option.data.mobileNo}</Link></li> : ''}

																							{option.data.telephoneNo != null ? <li> <i className="fa fa-mobile"></i></li> : ''}
																							{option.data.telephoneNo != null ? <li className="phoneInfo"> <Link>{option.data.telephoneNo && option.data.telephoneNo != null ? option.data.phoneCode2 : ''}- {option.data.telephoneNo}</Link></li> : ''}

																							{option.data.telephoneNo != null ? <li><p className="consultationFees " > 	<i className="fa"><img src={require('../../images/consultationfees_icon.png')} /></i></p></li> : ''}
																							{option.data.telephoneNo != null ? <li className="phoneInfo"> <p className="consultationFees " >Consultation Fees<span onClick={this.currencyApi.bind(this, option.data.currencySymbol, option.data.fee)}>{option.data.fee} {option.data.currencySymbol}</span></p></li> : ''}

																							<li className="wdtLi100">
																								<button type="button" className="btn btn-block btn-warning btn-sm requestApp" onClick={this.goToCalendarPageFromOtherConsulatation.bind(this, option.data._id, indexs)}><i className=" fa-calendar-check-o fa"></i>Request Appointment</button>
																							</li></div>) : ''}
																				</ul>
																			</div>
																		}
																	</div>

																</div>) : <div className="searchList  listings">
																	<div className="row">
																		<div className="text-center no-result"><h5>No Specialists Found</h5></div>
																	</div>
																</div> : <div className="searchList  listings">
																	<div className="row">
																		<div className="text-center no-result"><h5>Find your specialist(s)</h5></div>
																	</div>
																</div>}
															{(specialistList && specialistList.length > 0) ?
																<div className="row" style={{ 'marginTop': 30 }}>
																	<div className="col-sm-5 tablet_col12"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
																	<div className="col-sm-7 tablet_col12 text-right" style={{ "cursor": "pointer" }}>
																		<Pagination
																			prevPageText='Prev'
																			nextPageText='Next'
																			hideFirstLastPages
																			activePage={this.state.activePage}
																			itemsCountPerPage={15}
																			pageRangeDisplayed={15}
																			totalItemsCount={this.state.totalCount}
																			onChange={this.handlePageChange.bind(this)}
																		/>

																	</div>

																</div> : ''}
														</div>

													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<ConsultationAddress
							openModal={this.state.openModal}
							otherConsultationAddress={this.state.otherConsultationAddress}
							openConsultationModal={this.openConsultationModal.bind(this)}
							openConsultationModal={this.openConsultationModal.bind(this)}
							hideConsultationModal={this.hideConsultationModal.bind(this)}
							presentConsultationId={this.state.presentConsultationId}
							goToCalendarPageFromOtherConsulatation={this.goToCalendarPageFromOtherConsulatation.bind(this)}
						/>

					</section>
				}

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>

		);
	}
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		specialistList: state.specialist.specialistList,
		convertedCurrency: state.specialist.convertedCurrency,
		searchkey: state.specialist.searchkey,
		specializationList: state.specialist.specializationList,
		totalCount: state.specialist.specialistList.totalCount,
		otherConsultationAddress: state.specialist.otherConsultationAddress,
		questionRatings: state.specialist.questionRatings,
		listcurrencyFilter: state.specialist.listcurrencyFilter,
		specialistReducer: state.specialist

	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(BookAppointment);
